"use strict";

import toastr from 'toastr';
import 'toastr/./toastr.scss';

toastr.options = {
    "closeButton": true,
    "positionClass": "toast-top-right",
    "preventDuplicates": true,
    "showDuration": "300",
    "hideDuration": "1000",
    "timeOut": "5000",
    "extendedTimeOut": "1000",
    "showEasing": "swing",
    "hideEasing": "linear",
    "showMethod": "fadeIn",
    "hideMethod": "fadeOut"
};

function error(message, title){
    toastr["error"](message, title || "Error");
}

function success(message, title){
    toastr["info"](message, title || "Success");
}

export default{
    error : error,
    success : success
};



// WEBPACK FOOTER //
// /mnt/appdata/jenkins/jobs/EC_Registration/workspace/web/app/~/eslint-loader!./js/common/Notifier.js